import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class QuarryFlooded3PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.QUARRY_FLOODED3;
}

export default QuarryFlooded3PoiTileEntity;
